import { jsx } from 'react/jsx-runtime';
import { createVersionedContext, createVersionedValueMap } from '@backstage/version-bridge';
import { useContext } from 'react';

const AnalyticsReactContext = createVersionedContext("analytics-context");
const useAnalyticsContext = () => {
  const theContext = useContext(AnalyticsReactContext);
  if (theContext === void 0) {
    return {
      routeRef: "unknown",
      pluginId: "root",
      extension: "App"
    };
  }
  const theValue = theContext.atVersion(1);
  if (theValue === void 0) {
    throw new Error("No context found for version 1.");
  }
  return theValue;
};
const AnalyticsContext = (options) => {
  const { attributes, children } = options;
  const parentValues = useAnalyticsContext();
  const combinedValue = {
    ...parentValues,
    ...attributes
  };
  const versionedCombinedValue = createVersionedValueMap({ 1: combinedValue });
  return /* @__PURE__ */ jsx(AnalyticsReactContext.Provider, { value: versionedCombinedValue, children });
};

export { AnalyticsContext, useAnalyticsContext };
//# sourceMappingURL=AnalyticsContext.esm.js.map
